import * as React from "react";
import { Admin } from "@/interfaces";
import { UsersService } from "@/services";
import { Table } from "@/components/ui";
import UserTable from "../../UserTable";

const AdminsListFC: React.FC = () => {
  return (
    <UserTable
      hideSearch
      queryFunction={query => UsersService.getAdmins(query.page, query.size)}
      headers={[{ title: "Name" }, { title: "Email" }]}
      renderRow={(admin: Admin) => (
        <>
          <Table.Cell className="py-3">
            {admin.firstName} {admin.lastName}
          </Table.Cell>
          <Table.Cell className="py-3">{admin.email}</Table.Cell>
        </>
      )}
    />
  );
};

export const AdminsList = AdminsListFC;
